module.exports = __webpack_public_path__ + "assets/img/downpcap.b7b008d8.svg";